module.exports = __webpack_public_path__ + "img/source3_9.929fd1ee.png";